import { useMemo } from "react";
import ErrorBoundary from "@/components/shared/ErrorBoundary";
import TaskApprovalSection from "@/components/project/TaskApprovalSection";
import { useProjectDetailContext } from "@/contexts/ProjectDetailContext";

export default function ApprovalPage() {
  const { project, budgetLines, userMap, timeEntries } = useProjectDetailContext();

  // VIB-671 Task 11: bygg loggede-timer-maps fra time_entries så Oppgavestatus
  // kan vise "Xt brukt" per assignment. Prioriter assignment_id; fall tilbake
  // til budget_line_id for pre-VIB-671 data.
  const loggedHoursByAssignment = useMemo(() => {
    const m = new Map<string, number>();
    for (const te of timeEntries) {
      if (te.assignment_id) {
        m.set(te.assignment_id, (m.get(te.assignment_id) ?? 0) + (te.duration_seconds ?? 0) / 3600);
      }
    }
    return m;
  }, [timeEntries]);

  const loggedHoursByBudgetLine = useMemo(() => {
    const m = new Map<string, number>();
    for (const te of timeEntries) {
      if (te.budget_line_id) {
        m.set(te.budget_line_id, (m.get(te.budget_line_id) ?? 0) + (te.duration_seconds ?? 0) / 3600);
      }
    }
    return m;
  }, [timeEntries]);

  return (
    <ErrorBoundary>
      <TaskApprovalSection
        budgetLines={budgetLines}
        userMap={userMap}
        projectId={project.id}
        loggedHoursByAssignment={loggedHoursByAssignment}
        loggedHoursByBudgetLine={loggedHoursByBudgetLine}
      />
    </ErrorBoundary>
  );
}
